import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { CeoDrillDownModal } from "./CEOCommandCenter";

const PAGE_SIZE = 5000;

export default function PhysicalBarcodeStockDetail() {
  const navigate = useNavigate();
  const initial = useMemo(() => new URLSearchParams(window.location.search), []);
  const label = initial.get("label") || "";
  const title = initial.get("title") || "Physical Barcode Stock";
  const fromDate = initial.get("from") || "";
  const toDate = initial.get("to") || "";
  const reportTotalMcs = initial.get("mcs") || "0";
  const reportTotalKgs = initial.get("kgs") || "0";
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const body = useMemo(() => ({
    from_date: fromDate,
    to_date: toDate,
    grade: initial.get("grade") || "",
    variety: initial.get("variety") || "",
    cold_store: initial.get("cold_store") || "",
    plant: initial.get("plant") || "",
    page: 1,
    page_size: PAGE_SIZE,
    register_only: true,
    report_total_mcs: reportTotalMcs,
    report_total_kgs: reportTotalKgs,
  }), [initial, fromDate, toDate, reportTotalMcs, reportTotalKgs]);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError("");

    api.post("/ai/ceo-chat/stock-as-of", body, { timeout: 120000 })
      .then(async (response) => {
        const first = response.data || {};
        const register = first.register || {};
        const allRows = [...(register.rows || [])];

        for (let page = 2; page <= Number(register.total_pages || 1); page += 1) {
          const pageResponse = await api.post(
            "/ai/ceo-chat/stock-as-of",
            { ...body, page },
            { timeout: 120000 }
          );
          allRows.push(...(pageResponse.data?.register?.rows || []));
          if (cancelled) return;
        }

        if (!cancelled) {
          setData({
            ...first,
            register: { ...register, rows: allRows, page: 1 },
          });
        }
      })
      .catch((e) => {
        if (!cancelled) {
          setError(e?.response?.data?.detail || e?.message || "Unable to load supporting stock rows.");
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => { cancelled = true; };
  }, [body]);

  const register = data?.register || {};
  const reportData = data ? {
    columns: register.columns || [],
    rows: register.rows || [],
  } : null;
  const drill = useMemo(() => ({
    title: `${title} — ${label}`,
    metricField: "StockMCS",
    metricValue: data
      ? `${Number(data.total_mcs || 0).toLocaleString(undefined, { maximumFractionDigits: 2 })} MCS / ${Number(data.total_kgs || 0).toLocaleString(undefined, { maximumFractionDigits: 2 })} KGS`
      : null,
    payload: {
      directData: true,
      disableKpiFooter: true,
      activeDateRange: { from_date: fromDate, to_date: toDate },
    },
  }), [title, label, data, fromDate, toDate]);

  return (
    <CeoDrillDownModal
      drill={drill}
      data={reportData}
      loading={loading}
      error={error}
      onClose={() => navigate("/ceo-command-center?tab=store&focus=section-store-1-physical-barcode-stock")}
    />
  );
}
